export default __webpack_public_path__ + "static/media/image1.0.219d9d51.jpg";